<template>
    <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
    >
        <v-card>
            <v-card-title>
                <v-subheader>{{ $t('departments.form.data') }}</v-subheader>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >{{ $t('common.save') }}</v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-progress-linear :indeterminate="true" v-show="form.loading"></v-progress-linear>

            <v-card-text v-show="!form.loading">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="client.name"
                                :label="$t('departments.form.name.label')"
                                :rules="form.rules.name"
                                required
                                filled
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="client.primaryEmail"
                                :rules="form.rules.email"
                                :label="$t('departments.form.primaryEmail.label')"
                                required
                                filled
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="form.fieldMasks.commercialPhone"
                                :label="$t('departments.form.commercialPhone')"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                required
                                filled
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="form.fieldMasks.cellPhone"
                                :label="$t('departments.form.cellPhone')"
                                v-mask="['(##) ####-####', '(##) #####-####']"
                                required
                                filled
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea
                                required
                                filled
                                no-resize
                                :label="$t('departments.form.comments')"
                                v-model="client.comments"
                            ></v-textarea>
                        </v-col>

                        <v-col cols="12">
                            <v-switch
                                v-model="client.isActive"
                                :label="`${$t('departments.form.isActive')} (${(client.isActive) ? $t('common.yes') : $t('common.no')})`"
                                flat
                                inset
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >{{ $t('common.save') }}</v-btn>
            </v-card-title>
        </v-card>
    </v-form>
</template>

<script>
import API from '@/api'
import { mask } from 'vue-the-mask'

export default {
    name: 'form-client',
    metaInfo () {
        return {
            title: this.$t('departments.form.meta.title'),
            meta: [
                { name: 'description', content: this.$t('departments.form.meta.description') },
                { name: 'keywords', content: this.$t('departments.form.meta.keywords') }
            ]
        }
    },
    directives: {
        mask
    },
    data: function () {
        return {
            form: {
                isEdit: false,
                valid: false,
                rules: {
                    name: [
                        v => !!v || this.$t('departments.form.name.required'),
                        v => (v && v.length >= 3) || this.$t('departments.form.name.length')
                    ],
                    email: [
                        v => !!v || this.$t('departments.form.primaryEmail.required'),
                        v => /.+@.+/.test(v) || this.$t('departments.form.primaryEmail.test')
                    ]
                },
                loading: true,
                fieldMasks: {
                    commercialPhone: '',
                    cellPhone: ''
                }
            },
            client: {
                name: '',
                commercialPhone: '',
                cellPhone: '',
                isActive: true,
                comments: '',
                primaryEmail: '',
                parent: undefined
            }
        }
    },
    mounted () {
        if (this.$route.params.id != null) {
            this.loadData()
        } else {
            this.form.loading = false
        }
    },
    computed: {
        formMethod () {
            return (this.$route.params.id != null)
        }
    },
    methods: {
        loadData () {
            let endpoint = API.EndPoints.getClient
            let params = {
                objectId: this.$route.params.id
            }
            new API(endpoint, params).request().then(response => {
                this.client = Object.assign({}, response.data.result)
                this.form.fieldMasks.commercialPhone = this.client.commercialPhone
                this.form.fieldMasks.cellPhone = this.client.cellPhone
                this.form.isEdit = true
                this.form.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        formatObject () {
            this.client.commercialPhone = this.$helpers.unmask(this.form.fieldMasks.commercialPhone)
            this.client.cellPhone = this.$helpers.unmask(this.form.fieldMasks.cellPhone)
            const currentUserCompany = JSON.parse(localStorage.getItem('currentUserCompany'))
            this.client.parent = currentUserCompany?.parent?.objectId ?? currentUserCompany?.client?.objectId
            let params = JSON.stringify(this.client)
            return params
        },
        async save (boolean) {
            if (this.$refs.form.validate()) {
                this.form.valid = false
                if (boolean) {
                    this.update()
                } else {
                    this.create()
                }
            }
        },
        saveSuccess () {
            this.$router.push('/departamentos').catch(e => {})
        },
        create () {
            let endpoint = API.EndPoints.createClient
            new API(endpoint, this.formatObject()).request()
                .then((response) => {
                    this.saveSuccess()
                }, (e) => {
                    this.$helpers.requestError(e)
                })
        },
        update () {
            let endpoint = API.EndPoints.updateClient
            new API(endpoint, this.formatObject()).request()
                .then((response) => {
                    this.saveSuccess()
                }, (e) => {
                    this.$helpers.requestError(e)
                })
        }
    }
}
</script>

<style lang="stylus" scoped>
  .input-height
    height 57px
    position relative
</style>
